import { render, staticRenderFns } from "./goodsorder.vue?vue&type=template&id=7c2d1ea9&scoped=true&"
import script from "./goodsorder.vue?vue&type=script&lang=js&"
export * from "./goodsorder.vue?vue&type=script&lang=js&"
import style0 from "./goodsorder.vue?vue&type=style&index=0&id=7c2d1ea9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2d1ea9",
  null
  
)

export default component.exports